<template>
  <div class="new-wrapper construction-map">
    <div class="px-10">
      <breadcrumbs />
    </div>
    <iframe
      class="construction-map-frame"
      width="400"
      height="650"
      marginheight="0"
      marginwidth="0"
      scrolling="yes"
      frameborder="0"
      id="baumapframe"
      name="baumapframe"
      src="https://www.google.com/maps/d/u/0/embed?mid=13DFnofib0CTodJs1pK_pb6RC2oO_RMUU"
    ></iframe>
  </div>
</template>

<script>
import { metricParents, metricEventTypes } from "@/lib";
import {mapActions} from "vuex";
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";
// @ is an alias to /src

export default {
  name: "Bauprojekte",
  components: {Breadcrumbs},
  methods: {
    ...mapActions("metrics", ["postHeartbeat"])
  },
  mounted() {
    this.postHeartbeat({
      name: 'Bauprojekte',
      parent: metricParents.NONE,
      type: metricEventTypes.PAGE_VISIT,
    });
  }
};
</script>

<style scoped>
.construction-map-frame {
  display: block;
  width: 100%;
  height: calc(100vh - 64px);
  border: 0;
}
</style>
